import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';

const BASE_URL = 'https://rdfsedar.com/api/data/employees';

export const dropdownEmployeesFromSedarApi = createApi({
  reducerPath: 'dropdownEmployeesFromSedarApi',
  tagTypes: ['DropdownEmployeesFromSedar'],
  keepUnusedDataFor: 60 * 10,
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      headers.set('withCredentials', false);
      headers.set('Accept', 'application/json');
      headers.set('Authorization', `Bearer ${process.env.REACT_APP_SEDAR_KEY}`);
      headers.set('X-Auth-Token', `Bearer ${process.env.REACT_APP_SEDAR_KEY}`);

      return headers;
    },
  }),
  endpoints: (builder) => ({
    fetchDropdownEmployeesFromSedar: builder.query({
      query: (params) => ({
        url: '',
        method: 'GET',
        params,
      }),
      providesTags: ['DropdownEmployeesFromSedar'],
      keepUnusedDataFor: 10000,
      transformResponse: (response) => response.data,
    }),
  }),
});

export const { useFetchDropdownEmployeesFromSedarQuery } = dropdownEmployeesFromSedarApi;
